import React from 'react';
import './FAQ.scss';
import Item from './Item.js';
import { isYearAfter2024, getCurrentYear } from '../../../settings/settings';

export const FAQ = ({ isSalesforceRepRoth, customerWebViewEnabled }) => {
  const items = [
    {
      display: true,
      header: 'What are the requirements for a QCD?',
      content: (
        <div>
          <p style={{ marginBottom: '10px' }}>Generally,</p>
          <ul style={{ marginLeft: '40px', listStyleType: 'circle' }}>
            <li>
              You must be age 70½ or older on the date of the distribution.
            </li>
            <li>
              The distribution payment must be made directly to a qualified
              charity.{' '}
            </li>
            <li>
              The maximum annual exclusion from income per individual is up to $
              {isYearAfter2024() ? '108,000' : '105,000'} for {getCurrentYear()}{' '}
              (indexed for inflation).
            </li>
            <li>
              The distribution would otherwise be deductible as a charitable
              contribution under IRC Section 170.{' '}
            </li>
            <li>The distribution must be from an IRA.</li>
          </ul>
          <p style={{ marginTop: '10px' }}>
            {' '}
            T. Rowe Price does not provide tax advice; please consult your tax
            professional to discuss any questions you may have.
          </p>
        </div>
      ),
    },
    {
      display: true,
      header: 'What is the minimum age for making a QCD?',
      content: (
        <p>
          You must be at least 70 ½ at the time of the distribution. You can
          make a QCD after age 70 ½ even if you’re not yet subject to RMDs.
        </p>
      ),
    },
    {
      display: true,
      header: 'Which charities are eligible to receive my distribution?',
      content: (
        <div>
          <p style={{ marginBottom: '10px' }}>
            A qualified charity is an organization described in Internal Revenue
            Code (IRC) Section 170(b)(1)(A), generally a public charity that is
            eligible to receive tax-deductible contributions.{' '}
          </p>
          <p>
            Generally, the following are excluded: private foundations,
            donor-advised funds, and charitable supporting organizations.
            Beginning in 2023, a QCD may be taken to fund a Charitable Remainder
            UniTrust, Charitable Remainder Annuity Trust, or Charitable Gift
            Annuity up to a maximum one-time amount of $50,000.
          </p>
        </div>
      ),
    },
    {
      display: true,
      header: 'What is the maximum annual distribution for individuals?',
      content: (
        <p>
          The maximum annual exclusion from income per individual is up to $
          {isYearAfter2024() ? '108,000' : '105,000'} for {getCurrentYear()}{' '}
          (indexed for inflation). This $
          {isYearAfter2024() ? '108,000' : '105,000'} is reduced if you are
          making deductible IRA contributions after age 70 ½ . Please see IRS
          Publication 590-B, Distributions from Individual Retirement
          Arrangements (IRAs) for details.
        </p>
      ),
    },
    {
      display: true,
      header: 'Can I make a QCD from my employer-sponsored plan?',
      content: (
        <p>
          No, your distribution must be from an IRA. QCDs are not permitted from
          employer-sponsored retirement plans, including active SEP-IRA or
          SIMPLE IRA plans. An “active” SEP-IRA or SIMPLE IRA is one in which an
          employer contribution or salary reduction contribution is made for the
          plan year ending with or within the participant’s tax year in which
          the QCD would be made.
        </p>
      ),
    },
    {
      display: true,
      header: 'Can I make a QCD online from my inactive SEP-IRA or SIMPLE-IRA?',
      content: (
        <p>
          At this time, you can only make a QCD online from a Traditional,
          Rollover, Roth, and Roth Rollover IRA that you own. For all other IRA
          account types, please complete our{' '}
          {!customerWebViewEnabled && isSalesforceRepRoth ? (
            <span>QCD form (PDF)</span>
          ) : (
            <a
              href="https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf"
              rel="noreferrer"
              target="_blank"
            >
              QCD form (PDF)
            </a>
          )}
          .
        </p>
      ),
    },
    {
      display: true,
      header:
        'What if I’ve inherited an IRA or have power of attorney on an IRA?',
      content: (
        <p>
          You will need to complete our{' '}
          {!customerWebViewEnabled && isSalesforceRepRoth ? (
            <span>QCD form (PDF)</span>
          ) : (
            <a
              href="https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf"
              rel="noreferrer"
              target="_blank"
            >
              QCD form (PDF)
            </a>
          )}{' '}
          to request a QCD from the account. Or,{' '}
          {!customerWebViewEnabled && isSalesforceRepRoth ? (
            <span>contact T. Rowe Price</span>
          ) : (
            <a
              href="https://www.troweprice.com/personal-investing/help/contact/index.html"
              rel="noreferrer"
              target="_blank"
            >
              contact T. Rowe Price
            </a>
          )}{' '}
          to complete the form electronically.
        </p>
      ),
    },

    {
      display: true,
      header: 'What if I have a systematic withdrawal plan set up?',
      content: (
        <div>
          <p style={{ marginBottom: '10px' }}>
            You may reduce any remaining life expectancy payments by the QCD
            amount. You’ll be able to select this option when you make your QCD;
            however, you must make your QCD request before your deadline—April
            1st for your initial RMD or December 31st for subsequent year RMDs
          </p>
          <p>
            To allow time for processing, please submit this form at least 5
            days in advance of your next payment date. Failure to do so may
            prevent your systematic withdrawal program from being updated
            timely. This may result in more money being distributed than is
            necessary to satisfy your RMD.
          </p>
        </div>
      ),
    },

    {
      display: true,
      header: 'What are the tax implications and reporting for QCDs?',
      content: (
        <p>
          QCDs are federally tax free and are limited to the amount that would
          otherwise be taxed as ordinary income. However, a Form 1099-R will be
          issued to you and the IRS for this distribution.
        </p>
      ),
    },
  ];
  return (
    <div className="faq-container">
      <div className="title">Frequently Asked Questions</div>
      <div className="content">
        {items.map(({ header, content }) => (
          <Item header={header} content={content}></Item>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
